__turbopack_context__.v({
  "bottom": "zBxpgq_bottom",
  "desc": "zBxpgq_desc",
  "form": "zBxpgq_form",
  "header": "zBxpgq_header",
  "heading": "zBxpgq_heading",
  "img__m64Y8": "zBxpgq_img__m64Y8",
  "img__uwgCm": "zBxpgq_img__uwgCm",
  "label": "zBxpgq_label",
  "label7": "zBxpgq_label7",
  "label9": "zBxpgq_label9",
  "line": "zBxpgq_line",
  "link": "zBxpgq_link",
  "link___5Pv45": "zBxpgq_link___5Pv45",
  "logInBtn": "zBxpgq_logInBtn",
  "loginForm": "zBxpgq_loginForm",
  "loginFormResources": "zBxpgq_loginFormResources",
  "loginFormSecurity": "zBxpgq_loginFormSecurity",
  "logo": "zBxpgq_logo",
  "multiFactorAuthModal": "zBxpgq_multiFactorAuthModal",
  "notice": "zBxpgq_notice",
  "onChangeProvider": "zBxpgq_onChangeProvider",
  "password": "zBxpgq_password",
  "passwordInput": "zBxpgq_passwordInput",
  "passwordLabels": "zBxpgq_passwordLabels",
  "passwordProvider": "zBxpgq_passwordProvider",
  "root": "zBxpgq_root",
  "section": "zBxpgq_section",
  "serviceMessage": "zBxpgq_serviceMessage",
  "spinnerIcon": "zBxpgq_spinnerIcon",
  "svg___3R9Dl": "zBxpgq_svg___3R9Dl",
  "svg__c3Szl": "zBxpgq_svg__c3Szl",
  "svg__sMgbk": "zBxpgq_svg__sMgbk",
  "svg__u8Fqz": "zBxpgq_svg__u8Fqz",
  "text": "zBxpgq_text",
  "title": "zBxpgq_title",
  "usernameInput": "zBxpgq_usernameInput",
  "usernameProvider": "zBxpgq_usernameProvider",
  "usernameWrapper": "zBxpgq_usernameWrapper",
  "wrapper": "zBxpgq_wrapper",
});
